import React, { Component } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import img from '../../images/404.svg';
import { WithRouter } from '../../comp/WithRouter';

class Page404 extends Component {
  componentDidMount() {
    document.title = "Página não encontrada!";
  }

  render() {
    return (
      <Container
        component="section"
        maxWidth="md"
        sx={{
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          px: 3,
          py: 5
        }}
      >
        <Box
          component="img"
          src={img}
          alt="Página não encontrada"
          sx={{
            width: '100%',
            maxWidth: { xs: 280, sm: 400 },
            mb: 4,
            height: 'auto'
          }}
        />

        <Typography
          variant="h4"
          component="h1"
          fontWeight="bold"
          color="text.primary"
          gutterBottom
          sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
        >
          Oops! Página não encontrada!
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, maxWidth: 500 }}
        >
          A página que você está procurando não existe. Pode ter sido removida ou excluída.
        </Typography>

        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => this.props.navigate(-1)}
          sx={{
            bgcolor: '#7c4dff', // Mantendo a paleta roxa do seu MenuDrawer
            '&:hover': {
              bgcolor: '#673ab7',
            },
            borderRadius: 2,
            px: 4,
            py: 1,
            textTransform: 'none',
            fontWeight: 'bold'
          }}
        >
          Voltar
        </Button>
      </Container>
    );
  }
}

export default WithRouter(Page404);